import { Component, OnInit } from "@angular/core";
import { DialogConfig } from "libs/framwork/dialog/src/lib/dialog-config";
import { DialogRef } from "libs/framwork/dialog/src/lib/dialog-ref";
import { Router } from "@angular/router";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "pg-validation-dialog",
  templateUrl: "./validation-dialog.component.html",
  styleUrls: ["./validation-dialog.component.css"]
})
export class ValidationDialogComponent implements OnInit {
  parentComponentData: string;
  formGroup: FormGroup;

  dialogSetting: string;
  constructor(
    public dialogData: DialogConfig,
    private dialogRef: DialogRef,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.parentComponentData = this.dialogData.data.value;
  }

  onClose() {
    this.dialogRef.close(true);
  }

  onSave() {
    this.dialogRef.close(false);
  }
}
